import { ComposeAnalytics } from './compose';
import { consoleAnalytics } from './console';
import { SegmentAnalytics } from './segment-analytics';
import { zarazAnalytics } from './zaraz-analytics';
import { amplitudeAnalytics } from './amplitude-analytics';
export * as helpers from './helpers';

const destinations = [];
let segment: SegmentAnalytics | undefined;

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  // Needs to be  initialized outside of async function to ensure it is available globally
  // If this is not done, the SegmentAnalytics will not be available in the global scope and no events will be sent
  segment = new SegmentAnalytics();
  destinations.push(segment);

  // Initialize Analytics with a deployment strategy
  // Because Zaraz data is not business essential the strategy is to use for parallel testing
  // Amplitude SDK is the new standard for analytics and will be the default in the future
  // Zaraz is used for parallel testing and will be removed in the future
  // Segment sends the same data to Amplitude and because of this, we will incrementally switch to Amplitude SDK
  (async () => {
    // Get feature flags for Zaraz and Amplitude SDK (TO BE DONE when client feature flags are implemented)
    // Variables hard coded for now, but can be replaced with a feature flag service in the future
    const zarazSwitchOff: string = "off";
    const amplitudeSdkSwitchOn: string = 'off';

    if (amplitudeSdkSwitchOn === 'on') {
      if (segment) {
        // Remove SegmentAnalytics if Amplitude SDK is enabled
        // This is to prevent double tracking of events
        console.warn('Amplitude SDK is enabled, removing Segment Analytics');
        const index = destinations.indexOf(segment);
        if (index !== -1) destinations.splice(index, 1);
      }
    }

    if (zarazSwitchOff === 'off') {
      destinations.push(zarazAnalytics);
    }
    if (amplitudeSdkSwitchOn === 'on' || process.env.NODE_ENV === 'development') {
      destinations.push(amplitudeAnalytics);
    }
  })();

  // Development only - including non-dev deployments.
  if (process.env.NODE_ENV === 'development') {
    destinations.push(consoleAnalytics);
  }
}

export const analytics = new ComposeAnalytics(destinations);
